window.$ = window.jQuery;

export function handleStickyNav() {
    let $window = $(window);
    let $header = $('.js-header');

    let $progressbar = $(".js-progress-bar");

    let lastScroll = $window.scrollTop();
    let currentOffset = 0;

    let windowWidth = $window.outerWidth();

    $(window).on("scroll", function () {
        updateStickyNav();

        let scroll = $window.scrollTop();

        let diff = lastScroll - scroll;
        let height = $header.outerHeight();

        let bodyOffset = parseInt($('body').css('padding-top'));

        currentOffset = Math.min(0, Math.max(-height, currentOffset + diff));

        if (scroll <= 0) {
            currentOffset = 0;
        }

        if (scroll < bodyOffset) {
            currentOffset = -scroll;
        }

        lastScroll = scroll;

        if (currentOffset === 0) {
            $header.css("transform", "");

            if($progressbar.length > 0) {
                $progressbar.css("transform", "");
            }
        } else {
            $header.css("transform", "translate3d(0, " + currentOffset + "px, 0)");

            if($progressbar.length > 0) {
                $progressbar.css("transform", "translate3d(0, " + currentOffset + "px, 0)");
            }
        }

    }).on("resize", function () {
        let currentWidth = $window.outerWidth();

        if(windowWidth !== currentWidth){
            lastScroll = $window.scrollTop();
            currentOffset = 0;

            if($(window).outerWidth() < 960){
                $header.css("transform", "");
            }

            updateStickyNav();
        }

        windowWidth = currentWidth;
    });

    $(window).trigger("scroll");
}

export function updateStickyNav() {
    let scrollTop = $(window).scrollTop();

    if (scrollTop === 0) {
        $('body').removeClass('sticky-header');
        return;
    }

    if (scrollTop > $(".js-header").outerHeight()) {
        $('body').addClass('sticky-header');
    }
}
